export enum Iframes {
	Rx = 'rx',
	Viewer = 'viewer',
	Exocad3dViewer = 'exocad-3d-viewer',
	Analytics = 'analytics'
}
